import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-deep px-4 py-6 sm:px-6" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-19" data-mp="pjg7a5ljxg31">
        <h2 className="text-center font-heading text-xl font-extrabold uppercase text-gold sm:text-3xl" data-id="element-20" data-mp="avcxsm8avm9h">
          🎁 5 Professional Bonuses Included
        </h2>
        <div className="mt-4 space-y-3" data-id="element-21" data-mp="fsbrx4ryrt7o">
          {bonuses.map(bonus => <article key={bonus.number} className="rounded-xl border-l-4 border-gold bg-cream p-3 shadow-sm" data-id="element-22" data-mp="1tlufo18fris">
              <h3 className="font-heading text-[0.8rem] font-extrabold uppercase leading-tight text-petrol sm:text-base" data-id="element-23" data-mp="3o1lgyw505tlk">
                🎁 Bonus {bonus.number} — {bonus.title}
              </h3>
              <p className="mt-0.5 font-heading text-xs font-semibold text-sage sm:text-sm" data-id="element-24" data-mp="1ma8kmvh3ou14">
                {bonus.subtitle}
              </p>
              <p className="mt-1.5 text-sm leading-snug sm:text-base" data-id="element-25" data-mp="1r80e3txe8o7f">
                {bonus.body}
              </p>
              <p className="mt-1 font-heading text-xs font-bold uppercase tracking-wide text-gold sm:text-sm" data-id="element-26" data-mp="3iclm7offscw8">
                {bonus.steps}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}